import { render, staticRenderFns } from "./nachbarschaftshilfe.vue?vue&type=template&id=4155446c&scoped=true&"
import script from "./nachbarschaftshilfe.vue?vue&type=script&lang=js&"
export * from "./nachbarschaftshilfe.vue?vue&type=script&lang=js&"
import style0 from "./nachbarschaftshilfe.vue?vue&type=style&index=0&id=4155446c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4155446c",
  null
  
)

export default component.exports